<template>
    <modal size="md" @close="close">
        <div class="text-center">
            <h3 class="m-b-lg">
                Ny kontoindbetaling
            </h3>

            <div class="alert alert-info">
                Slip for de mange posteringer på dit kontoudtog ved at lave en indbetaling til din
              betterhype konto.<br />
                Vi bruger automatisk dit indestående før vi hæver penge på dit tilknyttede
                betalingskort.
            </div>

            <form @submit.prevent="update">
                <div class="m-xl">
                    <form-item field="amount" :form="form" class="form-group-lg">
                        <label class="control-label">Beløb</label>
                        <div class="input-group">
                            <span class="input-group-addon">DKK</span>
                            <input
                                v-model="form.amount"
                                type="number"
                                class="form-control input-lg text-right"
                                placeholder="Indtast beløb"
                                autofocus
                            />
                        </div>
                    </form-item>
                </div>
                <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busy">
                    Indbetal beløb
                </button>
            </form>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
/*.payment-icon {*/
/*width: 90px;*/
/*border-radius: 20px;*/
/*border: 1px solid #ccc;*/
/*}*/
</style>
<script type="text/babel">
export default {
    props: ['brand'],

    data() {
        return {
            form: new SparkForm({
                amount: 5000,
            }),
        }
    },

    methods: {
        update() {
            Spark.post(route('api.brand.deposits.store', this.brand.id), this.form).then(response => {
                // redirect to payment auth page
                if (response.redirect_url) {
                    window.location.href = response.redirect_url
                }

                this.$emit('success')
            })
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
